import { h, FunctionalComponent } from 'preact'
import { createContext } from 'preact-compat'
import { TranslationsDict } from './translations'

export interface TranslationsContextValue {
  translations: TranslationsDict | null
  registerPhrase: (module: string, phrase: string) => void
  getUsedTranslations: () => TranslationsDict
  language: string
}

export const TranslationsProvider: FunctionalComponent<{translations: TranslationsDict, language: string}> = ({ translations, children, language }) => {
  const translationsInUse: TranslationsDict = {}

  const props: TranslationsContextValue = {
    translations: translations,
    language: language,
    registerPhrase: (m, p) => {
      if (!translationsInUse[m]) translationsInUse[m] = {}
      translationsInUse[m][p] = translations?.[m]?.[p]
    },
    getUsedTranslations: () => {
      return translationsInUse
    }
  }
  return (
    <TranslationContext.Provider value={props}>
      {children}
    </TranslationContext.Provider>
  )
}

export const TranslationContext = createContext<TranslationsContextValue>({
  translations: null,
  registerPhrase: () => {},
  getUsedTranslations: () => ({}),
  language: 'en-US'
})
